import { ofType } from "redux-observable";
import { combineLatest, from } from "rxjs";
import { filter, switchMap, take } from "rxjs/operators";
import { actionBuildingsRewriteCenter } from "../../player-base/buildings/actionBuildings";
import { actionViewportClearCenter, TypeActionViewport } from "../actionViewport";
/**
 * Rewrites building center position so that after panning the viewport,
 * global/screen position still remains correct for the selected building.
 * @param action$
 * @param state$
 * @param deps
 */
export var epicViewportRewriteBuildingCenter = function (action$, state$, deps) {
    var centerOn$ = action$.pipe(ofType(TypeActionViewport.RequestClearCenter));
    var viewport$ = deps.inStoreDependencies.viewportChanged$.pipe(filter(function (viewport) { return !!viewport; }), take(1));
    return combineLatest(centerOn$, viewport$).pipe(switchMap(function (_a) {
        var action = _a[0], viewport = _a[1];
        var pos = viewport.toGlobal(viewport.center);
        return from([actionBuildingsRewriteCenter(pos), actionViewportClearCenter()]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/viewport/epics/epicViewportRewriteBuildingCenter.ts
// module id = 2502
// module chunks = 3